import { Pill } from "@accurx/inbox-design-library";
import styled from "styled-components";

export const StyledPillButton = styled(Pill.Dropdown)`
    min-width: 0;
    padding-left: 0.75rem;
`;

export const StyledPillText = styled(Pill.Text)`
    text-overflow: ellipsis;
    overflow: hidden;
`;
